import { apiRequest } from '../api-request'
import { ExceptionType, GOCException } from 'exceptions'
import { ClassResultPayload } from './class-result-adapter'

const saveClassResult = async (auth: string, classId: string, payload: ClassResultPayload): Promise<void> => {
    const effectiveAuth = process.env.REACT_APP_QUALWORLD_AUTH || auth

    if (!effectiveAuth.trim() || !classId.trim()) {
        throw new GOCException(ExceptionType.HttpError, 'Auth token and classId are required')
    }

    if (!process.env.REACT_APP_USE_ASSESSMENT_MOCKS) {
        return await apiRequest<undefined>({
            baseUrl: process.env.REACT_APP_CORE_COURSE_WEB_URL,
            path: `/bookapi/api/class/${classId}/result`,
            method: 'POST',
            auth: effectiveAuth,
            payload
        })
    } else {
        return new Promise(resolve => setTimeout(resolve, 300))
    }
}

export { saveClassResult }
